      function countdown(elementName, minutes, seconds) {
        var element, endTime, hours, mins, msLeft, time, ms;
        
        ms = 60;

        function twoDigits(n) {
          return n <= 9 ? "0" + n : n;
        }

        function updateTimer() {
          msLeft = endTime - +new Date();
          if (msLeft < 1000) {
            element.innerHTML = "Time is up!";
          } else {
            time = new Date(msLeft);
            hours = time.getUTCHours();
            mins = time.getUTCMinutes();
            element.innerHTML =
              (twoDigits(hours) + ":" + twoDigits(mins)) +
              ":" +
              twoDigits(time.getUTCSeconds());
            setTimeout(updateTimer, 500);
          }
        }

        element = document.getElementById(elementName);
        endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500;
        updateTimer();
      }

      countdown("ten-countdown-1", 10, 0);
      countdown("ten-countdown", 10, 0);